import { Assets, Container, Sprite } from "pixi.js"
import * as PIXI from 'pixi.js'
import { containers, gameAssets } from "../gameUI"
import { scaleFactor, tweenFade } from "../utility";
import { playPopTabChange, playPopUpClose } from "../soundManager";
import { gameData, networkData } from "../data";
import { formatBalance } from "../gameLogic";
import gsap from "gsap";

let isPopupOpen = false
let arrow1 = null;
let arrow2 = null; 

export const setupBetHistory = () => {
    if(!gameAssets.betHistoryBase){
        gameAssets.betHistoryBase = new Sprite(Assets.get('betHistory'))
    } 
    if(!containers.betHistoryContainer) containers.betHistoryContainer = new Container();
    containers.popupContainer.addChild(containers.betHistoryContainer);
    containers.popupContainer.visible = false;
    containers.popupContainer.alpha = 0
    containers.betHistoryContainer.visible = false
    gameAssets.betHistoryBase.anchor.set(0.5)

    containers.betHistoryContainer.addChild(gameAssets.betHistoryBase);

    const width = gameAssets.betHistoryBase.width
    const height = gameAssets.betHistoryBase.height
    gameAssets.betHistoryBase.resize = (w, h) => {
        const expandFactor = 0.85
        const scale = scaleFactor(gameAssets.gameScreen.width, width)
        gameAssets.betHistoryBase.x = w * 0.5
        gameAssets.betHistoryBase.y = h * 0.44
        gameAssets.betHistoryBase.width = width * scale * expandFactor
        gameAssets.betHistoryBase.height = height * scale * expandFactor
    } 

    const tutorialBtnGraphic = new PIXI.Graphics();
    gameAssets.betHistoryBase.addChild(tutorialBtnGraphic)
    tutorialBtnGraphic.beginFill(0x552155, 1);
    tutorialBtnGraphic.drawRect(0, 0, 525, 130);
    tutorialBtnGraphic.x = -265; 
    tutorialBtnGraphic.y = -1200;
    tutorialBtnGraphic.endFill();
    tutorialBtnGraphic.alpha = 0.01
    tutorialBtnGraphic.interactive = true
    tutorialBtnGraphic.cursor = 'pointer'
    tutorialBtnGraphic.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            playPopTabChange(true)
            containers.betHistoryContainer.visible = false;
            containers.settingsContainer.visible = false
            containers.tutorialContainer.visible = true
        }
    })

    const settingsBtnGraphic = new PIXI.Graphics();
    gameAssets.betHistoryBase.addChild(settingsBtnGraphic)
    settingsBtnGraphic.beginFill(0x552155, 1);
    settingsBtnGraphic.drawRect(0, 0, 520, 130);
    settingsBtnGraphic.x = -870; 
    settingsBtnGraphic.y = -1200;
    settingsBtnGraphic.name = "settings"
    settingsBtnGraphic.endFill();
    settingsBtnGraphic.alpha = 0.01
    settingsBtnGraphic.interactive = true
    settingsBtnGraphic.cursor = 'pointer'
    settingsBtnGraphic.on('pointerdown', (event)=>{
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            playPopTabChange(true)
            containers.betHistoryContainer.visible = false;
            containers.settingsContainer.visible = true
            containers.tutorialContainer.visible = false;
        }
    })

     if (!gameAssets.historyCloseBtn) gameAssets.historyCloseBtn = new Sprite(Assets.get('close_b_normal'))
    gameAssets.historyCloseBtn.anchor.set(0.5)
    gameAssets.betHistoryBase.addChild(gameAssets.historyCloseBtn)
    gameAssets.historyCloseBtn.x = 770
    gameAssets.historyCloseBtn.y = -860
    gameAssets.historyCloseBtn.interactive = true
    gameAssets.historyCloseBtn.buttonMode = true
    gameAssets.historyCloseBtn.zIndex = 100;
    gameAssets.historyCloseBtn.scale.set(1.5)
    gameAssets.historyCloseBtn.cursor = 'pointer'
    gameAssets.historyCloseBtn.on('pointerover', () => { gameAssets.historyCloseBtn.texture = Assets.get('close_b_selected') })
    gameAssets.historyCloseBtn.on('pointerout', () => { gameAssets.historyCloseBtn.texture = Assets.get('close_b_normal') })
    gameAssets.historyCloseBtn.on('pointerdown', (event) => {
        if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
            hidePopup()
        }
    })

    gameAssets.betHistoryContentContainer = new Container();
    gameAssets.betHistoryBase.addChild(gameAssets.betHistoryContentContainer)

    setupHeader();
    setupHistoryRows();
    setupArrow();

    gameAssets.betHistoryContentContainer.interactive = true;
    gameAssets.betHistoryContentContainer.cursor = 'grab';

    let isDragging = false;
    let dragStartX = 0;
    let startX = 0;

    gameAssets.betHistoryContentContainer.on('pointerdown', (event) => {
        isDragging = true;
        dragStartX = event.data.global.x;
        startX = gameAssets.betHistoryContentContainer.x;
        gameAssets.betHistoryContentContainer.cursor = 'grabbing';
    });

    gameAssets.betHistoryContentContainer.on('pointermove', (event) => {
        if (!isDragging) return;

        const deltaX = event.data.global.x - dragStartX;
        gameAssets.betHistoryContentContainer.x = startX + deltaX;

        gameData.betHistoryLeft = false;
        gameData.betHistoryRight = false;

        arrow1.visible = true;
        arrow2.visible = true;

        
        const minX = -1910; 
        const maxX = 10;      
        gameAssets.betHistoryContentContainer.x = Math.min(Math.max(gameAssets.betHistoryContentContainer.x, minX), maxX);
    });

    gameAssets.betHistoryContentContainer.on('pointerup', () => {
        isDragging = false;
        gameAssets.betHistoryContentContainer.cursor = 'grab';
    });

    gameAssets.betHistoryContentContainer.on('pointerupoutside', () => {
        isDragging = false;
        gameAssets.betHistoryContentContainer.cursor = 'grab';
    });
    
}

const setupArrow = () => {
    arrow1 = new PIXI.Sprite(PIXI.Assets.get('arrow_down'));
    arrow1.anchor.set(0.5);
    arrow1.angle = -90;
    arrow1.x = 970;
    arrow1.interactive = true;
    arrow1.cursor = 'pointer'
    arrow1.scale.set(2.6)

    arrow2 = new PIXI.Sprite(PIXI.Assets.get('arrow_down'));
    arrow2.anchor.set(0.5);
    arrow2.angle = 90;
    arrow2.x = -970;
    arrow2.interactive = true;
    arrow2.cursor = 'pointer'
    arrow2.scale.set(2.6)

    gameAssets.betHistoryBase.addChild(arrow1, arrow2);

    gsap.timeline({ repeat: -1, yoyo: true }) 
        .to([arrow1, arrow2], {
            pixi: {
                scale: 3.3
            },
            duration: 0.3,
            ease: "power1.inOut", 
    });

    arrow1.on('pointerdown', ()=>{
        gameData.betHistoryLeft = true;
        arrow1.visible = false;
        arrow2.visible = false;
    })

    arrow2.on('pointerdown', ()=>{
        gameData.betHistoryRight = true;
        arrow1.visible = false;
        arrow2.visible = false;
    })
}

export const setupHistoryLeft = (delta) => {
    gameAssets.betHistoryContentContainer.x = gameAssets.betHistoryContentContainer.x - 2 * delta;

    if(gameAssets.betHistoryContentContainer.x < -1860){
        gameData.betHistoryLeft = false;

    }
}

export const setupHistoryRight = (delta) => {    
    gameAssets.betHistoryContentContainer.x = gameAssets.betHistoryContentContainer.x + 2 * delta;

    if(gameAssets.betHistoryContentContainer.x > 0){
        gameData.betHistoryRight = false;
    }
}

const setupHistoryRows = () => {
    gameAssets.betHistoryRowContainer = new Container();
    gameAssets.betHistoryRowContainer.y = -425;

    gameAssets.mask2 = new PIXI.Sprite(PIXI.Assets.get('gameScreen'));
    gameAssets.mask2.anchor.set(0.5);
    gameAssets.mask2.scale.set(0, 1.5);
    gameAssets.mask2.alpha = 1;
    gameAssets.mask2.x = 0;
    gameAssets.mask2.y = 320;
    gameAssets.mask2.width = 1800;
    gameAssets.betHistoryRowContainer.mask = gameAssets.mask2;

    const width = gameAssets.betHistoryHeader.width + 25;

    for(let i = 0; i < 10; i++){
      gameAssets.rows[i] = new PIXI.Sprite(PIXI.Assets.get('history_row')); 
      gameAssets.rows[i].anchor.set(0, 0.5);

      const r_width = gameAssets.rows[i].width;
      const scale = width / r_width;

      gameAssets.rows[i].scale.set(scale, 1.1)
      gameAssets.rows[i].x = -890;

      gameAssets.rows[i].y = i * 168;

      gameAssets.betHistoryRowContainer.addChild(gameAssets.rows[i])
    }

    gameAssets.betHistoryBase.addChild(gameAssets.mask2);
    gameAssets.betHistoryContentContainer.addChild(gameAssets.betHistoryRowContainer);

}

const setupHeader = () => {
    gameAssets.betHistoryHeader = new Container();
    gameAssets.betHistoryHeader.x = -820;
    gameAssets.betHistoryHeader.y = -610;

    gameAssets.mask1 = new PIXI.Sprite(PIXI.Assets.get('gameScreen'));
    gameAssets.mask1.anchor.set(0.5);
    gameAssets.mask1.scale.set(0.16);
    gameAssets.mask1.alpha = 1
    gameAssets.mask1.x = 0
    gameAssets.mask1.y = -655
    gameAssets.mask1.width = 1800

    gameAssets.betHistoryBase.addChild(gameAssets.mask1);
    gameAssets.betHistoryHeader.mask = gameAssets.mask1

    const style = new PIXI.TextStyle({
        fill: "#000000",
        fontFamily: "Arial",
        fontSize: 73,
        fontWeight: "bold",
        align: "center",
        dropShadow: true,
        dropShadowColor: "#000000",
        dropShadowBlur: 2,
        dropShadowAngle: Math.PI / 4,
        dropShadowDistance: 1,
        stroke: "#000000",
        strokeThickness: 0
    });

    let spacing = [325, 840, 1355, 1685, 2070, 2630, 3115, 3470]

    for(let i = 0; i < gameAssets.historyContent.length; i++){
        const label = gameAssets.historyContent[i];
      
        const text = new PIXI.Text(label, style);
        text.anchor.set(0.5);

        if(i > 0) text.x = spacing[i - 1];
        if(i == 5 || i == 6 || i == 7) text.y = -35;

        gameAssets.betHistoryHeader.addChild(text)
    }

    gameAssets.betHistoryContentContainer.addChild(gameAssets.betHistoryHeader);
}

export const populateRows = () => {

    const style = new PIXI.TextStyle({
        fill: "#000000",
        fontFamily: "Arial",
        fontSize: 24,
        align: "center",
        dropShadow: true,
        dropShadowColor: "#000000",
        dropShadowBlur: 2,
        dropShadowAngle: Math.PI / 4,
        dropShadowDistance: 1,
        stroke: "#000000",
        strokeThickness: 0
    });

    networkData.betHist.map((value, index) => {
        const { bet_amount, result, date, time, beforebalance, afterbalance, winning_amount, multiplier, scores} = value;
        gameAssets.rows[index].removeChildren();
        const before = formatBalance(beforebalance, 2)
        const after = formatBalance(afterbalance, 2)
        const newWin = formatBalance(winning_amount, 2)
        const score = Array.isArray(scores) ? scores.join(',') : ''; 

        const text1 = new PIXI.Text(date, style);
        const text2 = new PIXI.Text(time, style);
        const text3 = new PIXI.Text(score, style);
        const text4 = new PIXI.Text(multiplier, style);
        const text5 = new PIXI.Text(bet_amount, style);
        const text6 = new PIXI.Text(before, style);
        const text7 = new PIXI.Text(after, style);
        const text8 = new PIXI.Text(newWin, style);
        const text9 = new PIXI.Text(result, style);

        let width = text3.width
        if(text3.width > 315){
            const scale = 315 / width;
            text3.scale.set(scale , 1.9)
        } else {
            text3.scale.set(1, 1.9);
        }
        let beforeWidth = text6.width;
        let afterWidth = text7.width

        if(beforeWidth > 220){
            const scale = 220 / beforeWidth;
            text6.scale.set(scale, 1.8)
        } else {
            text6.scale.set(1.1, 1.8);
        }
        if(afterWidth > 220){
            const scale = 220 / afterWidth;
            text7.scale.set(scale, 1.8)
        } else {
            text7.scale.set(1.1, 1.8)
        }

        text9.anchor.set(0.5);
        text8.anchor.set(0.5);
        text7.anchor.set(0.5);
        text6.anchor.set(0.5);
        text5.anchor.set(0.5);
        text4.anchor.set(0.5);
        text3.anchor.set(0.5);
        text2.anchor.set(0.5);
        text1.anchor.set(0.5);

        text1.scale.set(1, 1.8);
        text2.scale.set(1, 1.8);
        text4.scale.set(1, 1.8);
        text5.scale.set(1, 1.8);
        text8.scale.set(1, 1.8);
        text9.scale.set(1, 1.9);

        text1.x = 58;
        text2.x = 195
        text3.x = 430
        text4.x = 655;
        text5.x = 805;
        text6.x = 980;
        text7.x = 1245;
        text8.x = 1460
        text9.x = 1630

        gameAssets.rows[index].addChild(text1, text2, text3, text4, text5, text6, text7, text8, text9);
    })
}

export const hidePopup = () => {
    setIsPopupOpen(false)
    playPopUpClose(true)
    gameData.isPopupOpen = false;
    tweenFade(gameAssets.dimmer, false, 0.3)
    tweenFade(containers.popupContainer, false, 0.3, ()=>{
        containers.popupContainer.visible = false
        gameAssets.dimmer.visible = false;
        containers.settingsContainer.visible = true
        containers.tutorialContainer.visible = false
        containers.betHistoryContainer.visible = false;
    })
    containers.popupContainer.interactiveChildren = false
    gameAssets.footer.visible = true;
}

export const setIsPopupOpen = (isOpen) => {
    isPopupOpen = isOpen
}

export const getIsPopupOpen = () => isPopupOpen
